import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=b5b4e628"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=b5b4e628&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports